import React, { Component } from 'react'
import {
    FormControl,
    FormControlLabel,
    Checkbox,
    Autocomplete,
    TextField,
    ListSubheader,
} from '@mui/material'
import {
    FormInputLabel,
    selectionControlLabelProps,
} from '@/Components/Elements/StyledComponents/Input'
import {
    autocompleteGroupedSlotProps,
    optionGroupLabelSx,
} from '@/Components/Elements/StyledComponents/styles'
class DisplayItemListSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fast_switch:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.fast_switch
                    : null,
            checkbox_view:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.checkbox_view
                    : null,
            checkbox_view_horizontal:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.checkbox_view_horizontal
                    : null,
            default_list_option:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.default_list_option
                    : null,
        }

        this.fetchOptions = this.fetchOptions.bind(this)
    }

    fetchOptions(defFieldId) {
        const kedo = this.props.kedo
        let params = {
            params: {
                defField: defFieldId,
                limit: 500,
            },
        }
        this.setState({
            loading: true,
        })
        kedo.api()
            .getCached(kedo.api().getDefFieldListEndpoint(), params)
            .then((response) => {
                this.setState({
                    options: response.data.results,
                    loading: false,
                })
            })
            .catch((error) => {
                this.setState({
                    error: true,
                    loading: false,
                })
            })
    }

    componentDidMount() {
        if (
            this.props.item &&
            this.props.item.def_dossier_def_field &&
            this.props.item.def_dossier_def_field.def_field &&
            this.props.item.def_dossier_def_field.def_field.id
        ) {
            this.fetchOptions(
                this.props.item.def_dossier_def_field.def_field.id
            )
        }
    }

    getCurrentTranslationItem(listOption, locale) {
        if (listOption.translations && listOption.translations.length > 0) {
            let trans = listOption.translations.find(
                (option) => option.culture === locale.code
            )
            if (trans && trans.text) {
                return trans
            }
        }
        return false
    }

    getCurrentTranslationItemText(listOption, locale) {
        let found = this.getCurrentTranslationItem(listOption, locale)
        if (found) {
            return found.text
        }

        if (listOption.translations && listOption.translations.length > 0) {
            return listOption.translations[0].text
        }

        return listOption.id
    }

    render() {
        const kedo = this.props.kedo
        const locale = kedo.env().getSelectedLocale()
        const switchedOff = {
            id: null,
            label: kedo.t('Switched off'),
            group: '',
        }
        const listOptions = (this.state.options || []).map((listOption) => ({
            id: listOption.id,
            label: this.getCurrentTranslationItemText(listOption, locale),
            group: kedo.t('Options'),
        }))
        const options = [switchedOff, ...listOptions]
        const selected =
            options.find(
                (option) =>
                    option.id == null
                        ? this.state.default_list_option == null ||
                          this.state.default_list_option === ''
                        : String(option.id) ===
                          String(this.state.default_list_option)
            ) || switchedOff

        return (
            <div>
                <h3>List settings</h3>
                <FormControl fullWidth margin="normal">
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.fast_switch === true}
                                onChange={(e) => {
                                    this.setState({
                                        fast_switch: e.target.checked,
                                    })
                                    this.props.onChange(
                                        'fast_switch',
                                        e.target.checked
                                    )
                                }}
                                name="fast_switch"
                                disabled={this.props.disabled}
                            />
                        }
                        label={this.props.kedo.t('Fast switch')}
                        {...selectionControlLabelProps}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.checkbox_view === true}
                                onChange={(e) => {
                                    this.setState({
                                        checkbox_view: e.target.checked,
                                    })
                                    this.props.onChange(
                                        'checkbox_view',
                                        e.target.checked
                                    )
                                }}
                                name="checkbox_view"
                                disabled={this.props.disabled}
                            />
                        }
                        label={this.props.kedo.t('Basic view')}
                        {...selectionControlLabelProps}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={
                                    this.state.checkbox_view_horizontal === true
                                }
                                onChange={(e) => {
                                    this.setState({
                                        checkbox_view_horizontal:
                                            e.target.checked,
                                    })
                                    this.props.onChange(
                                        'checkbox_view_horizontal',
                                        e.target.checked
                                    )
                                }}
                                name="checkbox_view_horizontal"
                                disabled={this.props.disabled}
                            />
                        }
                        label={this.props.kedo.t('Horizontal view')}
                        {...selectionControlLabelProps}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {this.props.kedo.t('Select default option')}
                    </FormInputLabel>
                    <Autocomplete
                        size="small"
                        autoHighlight
                        options={options}
                        groupBy={(option) => option.group}
                        getOptionLabel={(option) => option.label || ''}
                        isOptionEqualToValue={(a, b) =>
                            a?.id == null
                                ? b?.id == null
                                : String(a.id) === String(b?.id)
                        }
                        value={selected}
                        disabled={this.props.disabled}
                        onChange={(_e, option) => {
                            const next = option?.id ?? null
                            this.setState({ default_list_option: next })
                            this.props.onChange('default_list_option', next)
                        }}
                        slotProps={autocompleteGroupedSlotProps}
                        renderGroup={(params) => (
                            <li key={params.key}>
                                {params.group ? (
                                    <ListSubheader
                                        component="div"
                                        sx={optionGroupLabelSx}
                                    >
                                        {params.group}
                                    </ListSubheader>
                                ) : null}
                                <ul style={{ padding: 0, margin: 0 }}>
                                    {params.children}
                                </ul>
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} size="small" />
                        )}
                    />
                </FormControl>
            </div>
        )
    }
}

export default DisplayItemListSettings
